import { Webhook } from 'types';
import React from 'react';

import KoalaTextBadge from 'koala/components/TextBadge';
import { useTranslation } from 'react-i18next';
interface Props {
  webhook: Webhook;
}

function WebhookActiveButton(props: Props) {
  const { webhook } = props;
  const { t } = useTranslation();

  if (!webhook.enabled) {
    return (
      <KoalaTextBadge variant="red-light" edge="circle" size="small">
        {t('workspaceSettingsWebhooks.disabled')}
      </KoalaTextBadge>
    );
  }

  if (webhook.failures_count > 0) {
    return (
      <KoalaTextBadge variant="yellow-light" edge="circle" size="small">
        {t('workspaceSettingsWebhooks.failing')}
      </KoalaTextBadge>
    );
  }

  return (
    <KoalaTextBadge variant="green-light" edge="circle" size="small">
      {t('workspaceSettingsWebhooks.enabled')}
    </KoalaTextBadge>
  );
}

export default WebhookActiveButton;
